const LocalStorage = {
    setItem(key: string, value: any, ttl: number): void {
        const data = {value, expires_at: new Date().getTime() + ttl};
        if (window.localStorage) {
            localStorage.setItem(key, JSON.stringify(data));
        }
    },
    getItem(key: string): any {
        if (!window.localStorage || !localStorage.getItem(key)) {
            return false;
        }
        const data = JSON.parse(localStorage.getItem(key) || '');
        if (data !== null) {
            if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
                localStorage.removeItem(key);
                return false;
            } else {
                return data.value;
            }
        }
        return null;
    },
};

const SessionStorage = {
    setItem(key: string, value: any, ttl: number): void {
        const data = {value, expires_at: new Date().getTime() + ttl};
        if (window.sessionStorage) {
            sessionStorage.setItem(key, JSON.stringify(data));
        }
    },
    getItem(key: string): any {
        if (!window.sessionStorage || !sessionStorage.getItem(key)) {
            return false;
        }
        const data = JSON.parse(sessionStorage.getItem(key) || '');
        if (data !== null) {
            if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
                sessionStorage.removeItem(key);
                return false;
            } else {
                return data.value;
            }
        }
        return null;
    },
};

export {LocalStorage, SessionStorage};



// WEBPACK FOOTER //
// ./src/helpers/storage.ts